import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';
import { SiteConfig } from '../shared';

ng.module('selfReg').run(confirmationRedirectConfig);

confirmationRedirectConfig.$inject = ['$window', '$transitions', 'config'];
function confirmationRedirectConfig(
   $window:ng.IWindowService,
   $transitions:uir.TransitionService,
   config:SiteConfig
) {
   if (config.settings.confirmationRedirect) {
      $transitions.onBefore({ to: 'shell.confirm'}, confirmationRedirect);
   }

   function confirmationRedirect(trans:uir.Transition) {
      trans.abort();

      let redirectUrl = config.settings.confirmationRedirect;
      if (redirectUrl.indexOf('{id}') !== -1) {
         redirectUrl = redirectUrl.replace('{id}', trans.params()['wristbandId']);
      }

      $window.location.href = redirectUrl;
   }
}
